module.exports = __webpack_public_path__ + "static/media/matilde-special-adventour-hello.72917884.png";